


















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  computed: {
    ...mapGetters('faqs', ['faqItems']),
  },
})
export default class TeachersFaq extends Vue {
  private expanded: boolean = true;

  private handleToggle() {
    this.expanded = !this.expanded;
  }
}
